/**
 * ローカル画像を取得する
 * @param fileName 
 */
function localImage(fileName: string): string {
    return `${process.env.PUBLIC_URL}/res/${fileName}`
}

export {localImage}